import {defineStore} from 'pinia'
import type {BlogCategory} from "~/graphql/generated/schema-types";

export const useBlogStore = defineStore('blogStore', () => {
    const categories = ref([] as BlogCategory[])


    return {
        categories
    }
})
